import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { fadeIn } from 'ng-animate';
import { ICurrency } from '../../../../shared/models/currency.model';
import { UtilService } from '../../../../shared/services/util/util.service';

interface IDonor {
  name?: string;
  entity?: {
    full_name?: string
  };
  full_name?: string;
}
interface Donor {
  name: string;
  avtar: boolean;
  donated_amount?: number;
  raised?: number;
  creation_date?: Date;
  initials?: string;
  currency?: string;
  product_sales?: any[];
}
@Component({
  selector: 'app-donor',
  templateUrl: './donor.component.html',
  styleUrls: ['./donor.component.scss'],
  animations: [
    trigger('fadeIn', [transition('* => *', useAnimation(fadeIn))])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DonorComponent implements OnInit, OnChanges {

  @Input() public donor;
  @Input() showTime = true;
  @Input() title;
  @Input() type;
  @Input() version = 1;
  donorObject: Donor;
  isDefaultUser = false;
  cdn;
  defaultImg;

  constructor(
    public utilService: UtilService
  ) { }

  ngOnInit() {
    this.defaultImg = this.utilService.defaultImg;
    // this.formatDonorData();
  }
  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges && simpleChanges.donor && simpleChanges.donor.currentValue) {
      this.donor = simpleChanges.donor.currentValue;
      this.formatDonorData();
    }
  }
  /**Format the different data object of donor */
  formatDonorData() {
    this.isDefaultUser = this.donor.is_anonymous === 1 ? true : false;
    this.donorObject = {
      name: this.getName(this.donor),
      avtar: this.getDonorAvtar(this.donor),
      donated_amount: this.getAmount(),
      raised: this.donor.donated_amount,
      creation_date: this.getDate(this.donor),
      product_sales: this.donor?.product_sales || undefined
      // currencyInfo: this.utilService.getCurrencyIcon(this.donor.iso_currency)
    };
    this.donorObject.initials = this.setName(this.donorObject.name);
  }
  getAmount() {
    if (this.type === 'supporter') {
      return this.donor.raised ? this.donor.raised.raised : '';
    } else if (this.type === 'social') {
      return this.donor.raised;
    } else {
      return this.donor.donated_amount_local;
    }
  }
  getName(data: IDonor) {
    if (data.name) {
      return data.name;
    } else if (data.entity) {
      return data.entity.full_name;
    } else if (data.full_name) {
      return data.full_name;
    } else {
      this.isDefaultUser = true;
      return 'Well Wisher';
    }
  }
  getDate(data) {
    if (data.creation_date) {
      return data.creation_date;
    } else if (data.activation) {
      return data.activation.creation_date;
    } else if (data.creation_time) {
      return data.creation_time;
    }
  }
  /**Set Name Initials  */
  setName(name) {
    return this.utilService.getInitialsOfName(name);
  }
  /**Get the AVtar of the donor from differen object */
  getDonorAvtar(data) {
    if (data.entity && data.entity.avtar) {
      this.cdn = data.entity.avtar.cdn_path;
      return true;
    } else if (data.donoravtar) {
      this.cdn = data.donoravtar.cdn_path;
      return true;
    } else if (data.avtar) {
      this.cdn = data.avtar.cdn_path;
      return true;
    } else {
      return false;
    }
  }

}
